class GridHelper
  constructor: (@wid, @hei, scrWidth, scrHeight, @easystar) ->
    @blocksize = 30
    @menuHeight = 0
    @halfScreenWidth = scrWidth >> 1
    @halfScreenHeight = scrHeight >> 1

  getGrid: (obj) =>
    [
      Math.min @wid - 1, Math.max(0, parseInt(obj.x / @blocksize))
      Math.min @hei - 1, Math.max(0, parseInt(obj.y / @blocksize))
    ]

  adjust: (subject, player) =>
    [
      subject.x - player.x + @halfScreenWidth
      subject.y - player.y + (@halfScreenHeight - @menuHeight)
    ]

  findPath: (subject, target, cb) =>
    [ @x, @y ] = @getGrid subject
    [ @targetX, @targetY ] = @getGrid target
    easystar.findPath @x, @y, @targetX, @targetY, (path) =>
      if path?.length > 0
        for newTarget in path
          if newTarget.x isnt @x or newTarget.y isnt @y
            break
      cb
        x: @x
        y: @y
        targetX: newTarget?.x
        targetY: newTarget?.y
    easystar.calculate()

module.exports = GridHelper
